import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

const FunctionalityItemLink = ({ title, to }) => {
  return (
    <Fragment>
      <NavLink to={to}>
        <li className="functionality__link">{title}</li>
      </NavLink>
    </Fragment>
  );
};

FunctionalityItemLink.propTypes = {
  title: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
};

export default FunctionalityItemLink;
